import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { SaveUserStateToServerHelper } from "./Helper";

import { start, nextExam } from "./../actions/assessment";

import config from "./../config/config-secret.json";

export class Ptsd extends Component {
    componentDidMount() {
        SaveUserStateToServerHelper(this.props.assessment);
    }

    start = () => {
        if (this.props.assessment.current_question_number === 1) {
            const tester_id = this.props.assessment.tester_id;

            axios
                .post(config.API_URL + "/administer_test/started/", {
                    tester_id: tester_id
                })
                .then(res => {
                    console.log(res.data);
                    document.querySelector("#initloader").style.display = "none";
                    this.props.start();
                })
                .catch(error => {
                    document.querySelector("#initloader").style.display = "none";
                    console.log(error);
                    alert("Something went wrong. Please refresh the page.");
                });
        } else {
            this.props.start();
        }
    };

    render() {
        return (
            <div className="main container-fluid h-100">
                <div className="row  h-50 justify-content-center align-items-center">
                    <div className="col-12">
                        <div className="container">
                            <div className="test">
                                <div className="question">
                                    <h4>
                                        <span>Sometimes things happen to people that are unusually or especially frightening, horrible, or traumatic. For example:</span>
                                    </h4>
                                    <div>
                                        <h5>
                                        <ul>
                                            <li>a serious accident or fire</li>
                                            <li>a physical or sexual assault or abuse</li>
                                            <li>an earthquake or flood</li>
                                            <li>a war</li>
                                            <li>seeing someone be killed or seriously injured</li>
                                            <li>having a loved one die through homicide or suicide</li>
                                        </ul>
                                        </h5>
                                    </div>
                                    <h4>
                                        <br />
                                        Have you ever experienced this kind of event?
                                    </h4>

                                    <div className="choices-btn" data-toggle="buttons">
                                        <label key="1" className="btn btn-outline-light rdb-choices" onClick={this.props.start}>
                                            <input
                                                type="radio"
                                                name="choices"
                                                id="btnPtdsYes"
                                                value="1"
                                                disabled
                                            />
                                            <span className="letter-choice">A</span>
                                            Yes
                                        </label>
                                        <label key="2" className="btn btn-outline-light rdb-choices" onClick={this.props.nextExam}>
                                            <input
                                                type="radio"
                                                name="choices"
                                                id="btnPtdsNo"
                                                value="0"
                                                disabled
                                            />
                                            <span className="letter-choice">B</span>
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    start: () => dispatch(start()),
    nextExam: () => dispatch(nextExam())
});

export default connect(mapStateToProps, mapDispatchToProps)(Ptsd);
